import Router from 'next/router';
import { useEffect } from 'react';

let LUX;

const useSpeedcurve = (route) => {
  if (process.browser) {
    LUX = window.LUX || {};
    LUX.auto = false;
    LUX.label = route;
  }
  useEffect(() => {
    const handleRouteChange = () => {
      if (LUX?.init) {
        LUX.init();
        LUX.label = route;
      }
    };
    const handleRouteCompleteChange = () => {
      if (LUX?.send) LUX.send();
    };
    Router.events.on('routeChangeStart', handleRouteChange);
    Router.events.on('routeChangeComplete', handleRouteCompleteChange);
    return () => {
      Router.events.off('routeChangeStart', handleRouteChange);
      Router.events.off('routeChangeComplete', handleRouteCompleteChange);
    };
  }, [route]);
};

export default useSpeedcurve;
